import { Component, HostListener, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AbstractBaseListComponent } from '../../../core/component/abstract-base-list-component';
import { SalesOrderModal } from '../modal/sales-order-modal';
import { IBaseService } from '../../../core/service/ibase-service';
import { FileUtilService } from '../../../core/service/FileUtil/file-util.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SalesOrderServiceService } from '../service/sales-order-service.service';
import { LocalDataSource } from 'ng2-smart-table';
import { Row } from 'ng2-smart-table/lib/data-set/row';
import { PartyModal } from '../../party/modal/party-modal';
import { ResponseCode } from '../../../core/constant/response-code';
import { DateFormatPipe } from '../../../core/pipe/dateFormat/date-format.pipe';
import { Ng2SmartTableLabelComponent } from '../../../shared/shared-crm/ng2-smart-table-label/ng2-smart-table-label.component';
import { DatePipe } from '@angular/common';
import { ModuleParamGlobConfigService } from '../../../core/service/moduleFieldConfig/module-param-glob-config.service';
import { PaginationData } from '../../../core/modal/pagination-data';
import { OrderingData } from '../../../core/modal/ordering-data';
import { soModuleParamConfigModel } from '../modal/so-module-param-config-model';
import { getColumnExists, getColumnObject } from 'src/app/core/utils/helpers';
import { ColumnModel } from 'neo-table-lib';
import { MatTableDataSource } from '@angular/material';
import { CommonSelectListService } from 'src/app/shared/service/common-select-list.service';
import { AclDataModal } from '../../../shared/sidebar/acl-data-modal';
import { environment } from '../../../../environments/environment';
import { SearchData } from '../../../core/modal/search-data';
import { StatusConstant, StatusConstantForApproval } from '../../../core/constant/status-constant';
import { ApprovalConfigLog } from '../../approval-generic/model/approval-log';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TableKeyEnum } from 'src/app/core/enum/table-key.enum';
import { SystemConfigSettingModel } from '../../../shared/model/system-config-setting-model';
import { SystemConfigService } from '../../../system-config/service/system-config.service';

@Component({
  selector: 'app-sales-order-list',
  templateUrl: './sales-order-list.component.html',
  styleUrls: ['./sales-order-list.component.css'],
})
export class SalesOrderListComponent extends AbstractBaseListComponent<SalesOrderModal> implements OnInit {
  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.onHeaderRefresh();
  }
  @ViewChild('actionCol') actionCol: TemplateRef<any>;
  @ViewChild('party') partyReff: TemplateRef<any>;
  @ViewChild('generatedFromLabelWrapper') generatedFromLabelWrapperRef: TemplateRef<any>;
  private readonly MODULE_PARAM_CONFIG_KEY: string = 'salesOrder';
  allColumns: any[] = [
    {
      colKey: 'index',
      default: 'Sr No.',
      rowKey: 'id',
      isNumber: true,
      width: '8%',
    },
    {
      colKey: 'dateString',
      default: this.moduleParamConfigGlobService.getLabel(this.MODULE_PARAM_CONFIG_KEY, 'so_date', 'SO Date'),
      rowKey: 'dateString',
      dateFormat: 'dd-MM-yyyy',
      isNumber: false,
      isFilterAllow: false,
      enableEdit: true,
      enableDelete: true,
      enableSort: true,
      width: '104px'
    },
    {
      colKey: 'soNumber',
      default: this.moduleParamConfigGlobService.getLabel(this.MODULE_PARAM_CONFIG_KEY, 'so_number', 'SO Number'),
      rowKey: 'soNumber',
      isNumber: false,
      isFilterAllow: false,
      enableEdit: true,
      enableDelete: true,
      enableSort: true,
      width: '137px',
    },
    {
      colKey: 'quotationNo',
      default: 'Quotation No.',
      rowKey: 'quotationNo',
      isNumber: false,
      isFilterAllow: false,
      enableEdit: true,
      enableDelete: true,
      enableSort: true,
      width: '137px',
    },
    {
      colKey: 'GeneratedFrom',
      default: 'Generated Form',
      rowKey: 'generatedform',
      isHTMLContent: true,
      customControls: null,
      isNumber: false,
      isFilterAllow: false,
      enableEdit: true,
      enableDelete: true,
      enableSort: true,
      width: '150px',
    },
    {
      colKey: 'name',
      default: this.moduleParamConfigGlobService.getLabel(this.MODULE_PARAM_CONFIG_KEY, 'so_name', 'SO Name'),
      rowKey: 'name',
      isNumber: false,
      isFilterAllow: false,
      enableEdit: true,
      enableDelete: true,
      enableSort: true,
      width: '140px',
    },
    {
      colKey: 'partyString',
      default: this.moduleParamConfigGlobService.getLabel(this.MODULE_PARAM_CONFIG_KEY, 'party_name', 'Party Name'),
      rowKey: 'partyString',
      isNumber: false,
      isFilterAllow: false,
      enableEdit: true,
      enableDelete: true,
      enableSort: true,
      width: '20%',

    },
    {
      colKey: 'remark',
      default: 'Destination',
      rowKey: 'remark',
      isNumber: false,
      isFilterAllow: false,
      enableEdit: true,
      enableDelete: true,
      enableSort: true,
    },
    {
      colKey: 'soStatusString',
      default: 'SO Status',
      rowKey: 'soStatusString',
      isNumber: false,
      isFilterAllow: false,
      enableEdit: true,
      enableDelete: true,
      enableSort: true,
      width:'105px'
    },
    {
      colKey: 'statusString',
      default: 'Status',
      rowKey: 'statusString',
      isNumber: false,
      isFilterAllow: false,
      enableEdit: true,
      enableDelete: true,
      enableSort: true,
      width:'87px'
    },
    {
      colKey: 'actionCol',
      default: 'Action',
      rowKey: 'id',
      isNumber: false,
      isStickyEnd: true,
      width: '8%'
    },
  ];
  allFinalColumns: ColumnModel[] = [];
  public dataList: Array<SalesOrderModal>;
  addUpdateUrl: string = 'module/sales-order/addUpdateSalesOrder';
  dataSource = new MatTableDataSource([]);
  moduleParamModel: soModuleParamConfigModel = new soModuleParamConfigModel(this.moduleParamConfigGlobService);
  salesTitle = this.moduleParamModel.paramData.so_title.label;
  @Input() getAllFilter: boolean;
  @Input() getAllFilterUrl: string;
  displayedColumns: string[];
  filteredData: any;
  allDataList: SalesOrderModal[];
  selectedType: boolean;
  selectedParty: Array<PartyModal>;
  partyList: PartyModal[];
  tableKeyEnum = TableKeyEnum.SALES_ORDER;
  defaultSortCol = 'date';
  defaultSortDirection = 'desc';
  priceBookNeoGridSettings: any = {};
  statusForApproval: any;
  public statusListForApproval = StatusConstantForApproval;
  moduleId: number;
  selectedSO: SalesOrderModal;
  approvalConfigLog: Array<ApprovalConfigLog>;
  private ngbRef: NgbModalRef;
  isApprovedAllowed: boolean;
  selectedID: number;
  @ViewChild('printButton') printButtonRef: TemplateRef<any>;
  public statusList = StatusConstant;
  public status: any;
  isHideHeaderFooter: boolean = false;
  isWorkOrder: boolean = false;
  data: SalesOrderModal;
  public sysConfigModel: SystemConfigSettingModel = new SystemConfigSettingModel(this.systemConfigService);
  isLifeoline: boolean;
  constructor(
    public service: SalesOrderServiceService,
    public fileUtil: FileUtilService,
    private route: ActivatedRoute,
    private commonService: CommonSelectListService,
    private router: Router,
    public toastrService: ToastrService,
    private systemConfigService: SystemConfigService,
    private moduleParamConfigGlobService: ModuleParamGlobConfigService,
    private ngbModalService: NgbModal
  ) {
    super(toastrService, router);
  }
  ngOnInit() {
    if (!this.orderingData) {
      this.orderingData = new OrderingData();
      this.orderingData.column = 'id';
      this.orderingData.descending = false;
    }
    this.paginatioData = new PaginationData();
    this.onFilterChange(null);
    this.initAclForSO();
    this.setTableColumns();
    this.checkPartnerName();
  }

  checkPartnerName() {
    if (this.sysConfigModel.partnerKey == 'Alaska' && this.sysConfigModel.printPartner == 'Lifeoline') {
      this.isLifeoline = true;
    } else {
      this.isLifeoline = false;
    }
  }

  getListWithParams(isPDF?) {
    let config = { page: this.paginatioData, order: this.orderingData, search: this.searchData };
    this.getMaterialRequestData(config, isPDF);
  }

  getMaterialRequestData(config, isPDF?) {
    let params = this.getGridSettingInfo(config);
    if (isPDF) {
      if (isPDF == 'pdf') {
        this.generatePdf(params);
      } else {
        this.generateCSV(params);
      }
    } else {
      this.service.getAllByPagination(params).subscribe((res) => {
        this.setList(res.dataList);
        this.totalRecords = res.totalRecords;
        this.priceBookNeoGridSettings.pageTotalLength = this.totalRecords;
      });
    }
  }

  initAclForSO() {
    try {
      this.isDeleteAllow = !this.hideDeleteButton();
      let aclModule: Map<string, AclDataModal> = new Map<string, AclDataModal>();
      let aclDataString = localStorage.getItem(environment.ACL_LOCAL_KEY);
      if (aclDataString) {
        aclModule = new Map(JSON.parse(aclDataString));
        let serviceName: string = this.getService().getModuleName();
        let acl: AclDataModal = aclModule.get(serviceName);

        if (acl) {
          this.isAddAllow = acl.create == 1;
          this.isDeleteAllow = acl.delete == 1 && !this.hideDeleteButton();
          this.isEditAllow = acl.update == 1;
          this.isViewAllow = acl.view == 1;
        }
      }
    } catch (e) {
      console.error('Error in initAcl', e);
    }
  }

  getPartyList() {
    if (!this.partyList || this.partyList.length == 0) {
      this.commonService.getCustomerListOptimized().subscribe((response) => {
        if (response.responseCode === ResponseCode.OK) {
          this.partyList = new Array<PartyModal>();
          this.partyList = response.dataList;
        } else {
          this.toastrService.error(response.responseMessage, 'Error');
        }
      });
    }
  }

  getService(): IBaseService<SalesOrderModal> {
    return this.service;
  }

  setList(list: Array<SalesOrderModal>) {
    this.allDataList = list;
    let obj = {
      keyName: 'so_approval_flow',
    };
    this.commonService.getModuleApproval(obj).subscribe((res) => {
      if (res.data && res.data.isActive) {
        this.isApprovedAllowed = true;
      } else this.isApprovedAllowed = false;
    });
    this.valuePrepareFunction(this.allDataList);
    this.setDataSource(this.allDataList);
  }

  public getTableColumn(): any {
    let columnList = {
      dateString: {
        title: this.moduleParamConfigGlobService.getLabel(this.MODULE_PARAM_CONFIG_KEY, 'so_date', 'SO Date'),
        filter: false,
        compareFunction: this.sortDate,
      },
      soNumber: {
        title: this.moduleParamConfigGlobService.getLabel(this.MODULE_PARAM_CONFIG_KEY, 'so_number', 'SO Number'),
        filter: false,
      },
      generatedFrom: {
        title: 'Generated From',
        filter: false,

        // type: 'html',
        // valuePrepareFunction: (generatedFrom) => {
        //   if (generatedFrom && generatedFrom.toUpperCase() === 'QUOTATION') {
        //     return '<h4><span class="badge badge-info font-weight-bolder">Quotation</span></h4>';
        //   } else {
        //     return '<h4><span class="badge badge-success text-dark font-weight-bolder"> Sales Order</span></h4>';
        //   }
        // }
      },
      name: {
        title: this.moduleParamConfigGlobService.getLabel(this.MODULE_PARAM_CONFIG_KEY, 'so_name', 'SO Name'),
        filter: false,
      },
      partyString: {
        title: this.moduleParamConfigGlobService.getLabel(this.MODULE_PARAM_CONFIG_KEY, 'party_name', 'Party Name'),
        filter: false,
      },
      remark: {
        title: 'remark',
        filter: false,
      },
    };
    return columnList;
  }
  setTableColumns() {
    // Input Table Columns
    if (!this.isApprovedAllowed) {
      this.allColumns = [
        {
          colKey: 'index',
          default: 'Sr No.',
          rowKey: 'id',
          isNumber: true,
          width: '60px',
        },
        {
          colKey: 'dateString',
          default: this.moduleParamConfigGlobService.getLabel(this.MODULE_PARAM_CONFIG_KEY, 'so_date', 'SO Date'),
          rowKey: 'dateString',
          dateFormat: 'dd-MM-yyyy',
          isNumber: false,
          isFilterAllow: false,
          enableEdit: true,
          enableDelete: true,
          enableSort: true,
          width: '104px'
        },
        {
          colKey: 'soNumber',
          default: this.moduleParamConfigGlobService.getLabel(this.MODULE_PARAM_CONFIG_KEY, 'so_number', 'SO Number'),
          rowKey: 'soNumber',
          isNumber: false,
          isFilterAllow: false,
          enableEdit: true,
          enableDelete: true,
          enableSort: true,
          width: '137px',
        },
        {
          colKey: 'quotationNo',
          default: 'Quotation No.',
          rowKey: 'quotationNo',
          isNumber: false,
          isFilterAllow: false,
          enableEdit: true,
          enableDelete: true,
          enableSort: true,
          width: '137px',
        },
        {
          colKey: 'GeneratedFrom',
          default: 'Generated Form',
          rowKey: 'generatedform',
          isHTMLContent: true,
          customControls: null,
          isNumber: false,
          isFilterAllow: false,
          enableEdit: true,
          enableDelete: true,
          enableSort: true,
          width: '160px',
        },
        {
          colKey: 'name',
          default: this.moduleParamConfigGlobService.getLabel(this.MODULE_PARAM_CONFIG_KEY, 'so_name', 'SO Name'),
          rowKey: 'name',
          isNumber: false,
          isFilterAllow: false,
          enableEdit: true,
          enableDelete: true,
          enableSort: true,
          width: '140px',
        },
        {
          colKey: 'partyString',
          default: this.moduleParamConfigGlobService.getLabel(this.MODULE_PARAM_CONFIG_KEY, 'party_name', 'Party Name'),
          rowKey: 'partyString',
          isNumber: false,
          isFilterAllow: false,
          enableEdit: true,
          enableDelete: true,
          enableSort: true,
          width: '110px',
        },
        {
          colKey: 'remark',
          default: 'Destination',
          rowKey: 'remark',
          isNumber: false,
          isFilterAllow: false,
          enableEdit: true,
          enableDelete: true,
          enableSort: true,
          width:'105px'
        },
        {
          colKey: 'soStatusString',
          default: 'SO Status',
          rowKey: 'soStatusString',
          isNumber: false,
          isFilterAllow: false,
          enableEdit: true,
          enableDelete: true,
          enableSort: true,
          width:'87px'
        },
        {
          colKey: 'actionCol',
          default: 'Action',
          rowKey: 'id',
          isNumber: false,
          isStickyEnd: true,
          width: '130px',
        },
      ];
    }
    this.allColumns.map((column, columnIndex) => {
      // column.isFilterAllow = true;
      column.enableEdit = this.isEditAllow;
      column.enableDelete = this.isDeleteAllow;
      let pushcol = false;
      column.isFilterAllow = false;
      column.enableSort = false;
      if (column.colKey == 'GeneratedFrom') {
        pushcol = true;
        column.customControls = [this.generatedFromLabelWrapperRef];
      } else if (column.colKey == 'actionCol') {
        pushcol = true;
        column.enableEdit = false;
        column.enableDelete = false;
        column.customControls = [this.actionCol, this.printButtonRef];
        column.isExpandable = false;
      } else {
        pushcol = true;
      }

      const pushcolVal = getColumnObject(column);
      if (pushcol && !getColumnExists(this.allFinalColumns, column.colKey)) {
        this.allFinalColumns.splice(columnIndex, 0, pushcolVal);
      }
    });
    this.priceBookNeoGridSettings = {
      showAdvanceSearch: true,
      showFooter: true,
      showPagination: true,
      showFilter: true,
      tableId: this.tableKeyEnum,
      perPage: 10,
      pageSizeOptions: [5, 10, 15, 20, 50, 100],
      serverSideSortPagination: true,
      serverSideFilter: true,
      pageTotalLength: 0,
      sort: true,
      defaultSortCol: '',
      defaultSortDirection: 'asc',
      columns: this.allColumns,
    };
    this.displayedColumns = this.allFinalColumns.map((column) => column.colKey);
    if (this.priceBookNeoGridSettings.serverSideSortPagination && this.priceBookNeoGridSettings.perPage) {
      this.setPaginationPerPage(this.priceBookNeoGridSettings.perPage);
    }
  }

  ngAfterViewInit() {
    this.allColumns.forEach((col) => {
      if (col.colKey == 'partyString') {
        col.customControls = [this.partyReff];
      }
    });
  }
  public onDeleteClick(data: SalesOrderModal) {
    if (confirm('Are you sure want to delete this record.')) {
      this.service.delete(data).subscribe((response) => {
        if (response.responseCode != ResponseCode.OK) {
          this.onResponseError(response.responseMessage);
          return;
        }
        this.toastrService.success('Data has been deleted successfully.', 'Success');
        this.onFilterChange(null);
      });
    }
  }

  public onEditClick(modal: SalesOrderModal) {
    this.router.navigate([this.addUpdateUrl, modal.id]);
  }

  onSmartTableEditClick(eventData: Row) {
    this.onEditClick(eventData.getData());
  }

  onSmartTableDeleteClick(eventData: Row) {
    this.onDeleteClick(eventData.getData());
  }

  onNeoTableEditClick(event) {
    let index = event.rowIndex;
    this.onEditClick(this.filteredData[index]);
  }

  onNeoTableDeleteClick(event) {
    let index = event.rowIndex;
    this.onDeleteClick(this.filteredData[index]);
  }
  setToService() {
    let Obj = {
      pageIndex: this.dataSource.paginator.pageIndex,
      perPage: (this.dataSource.paginator.pageSize = 10),
    };

    this.service.pagination = Obj;
  }
  onHeaderRefresh($event: void) {
    this.onFilterChange(null);
  }

  async generatePdf(data) {
    if (!data) this.onFilterChange(null, 'pdf');
    else this.commonService.exportToPDFSO(data);
  }

  async generateCSV(data) {
    if (!data) this.onFilterChange(null, 'excel');
    else this.commonService.exportToExcelSO(data);
  }

  valuePrepareFunction(list: SalesOrderModal[]) {
    list.forEach((data) => {
      data.dateString = new DateFormatPipe('en-EN').transform(data.date, 'dd-MM-yyyy');
      data.partyString = data.party ? data.party.companyName : '';
      data.generatedFrom =
        data.generatedFrom && data.generatedFrom.toLowerCase() === 'quotation'
          ? 'Quotation'
          : this.moduleParamModel.paramData.so_from_label.label;
      data.generatedFromLable = '';
      data.soStatusString = data.status ? data.status.statusName : '';
      data.statusString = data.approvalStatus ? data.approvalStatus.statusName : '';
    });
    this.allDataList = list;
  }

  setDataSource(data) {
    this.dataSource = new MatTableDataSource(JSON.parse(JSON.stringify(data)));
    this.dataSource.connect().subscribe((data) => {
      this.filteredData = data;
    });
    // if (this.service.pagination) setTimeout(() => this.assignValue(), 0);
  }

  assignValue() {
    this.dataSource.paginator.pageIndex = this.service.pagination.pageIndex;
    this.dataSource.paginator.pageSize = this.service.pagination.perPage;
  }

  onFilterChange(filterObj, isPDF?) {
    let serverFilterObj: SearchData[] = this.service.getServerFilterObj();
    if (filterObj) {
      let searchData = new SearchData();
      searchData = filterObj;
      filterObj['filter'] = filterObj['filter'].trim();
      searchData.filterValue = filterObj['filter'];
      this.paginatioData.pageNumber = 1;
      if (searchData.filterValue) {
        searchData.filterColumn = 'SearchBox';
        serverFilterObj = this.service.setServerFilterObj([searchData]);
      } else {
        serverFilterObj = new Array<SearchData>();
      }
    } else {
      serverFilterObj = new Array<SearchData>();
    }

    if (this.status) {
      let objPoStatus: SearchData = {
        filterColumn: 'status',
        filterValue: this.status,
        filterOperator: null,
        filterCondition: null,
        filterDataType: null,
      };
      serverFilterObj.push(objPoStatus);
    }
    if (serverFilterObj && serverFilterObj.length > 0) {
      serverFilterObj = serverFilterObj.filter((ls) => ls.filterColumn != 'party');
    }
    let objPoPartyList: SearchData = {
      filterColumn: 'party',
      filterValue: null,
      filterOperator: null,
      filterCondition: null,
      filterDataType: null,
    };
    if (this.selectedParty && this.selectedParty.length > 0)
      objPoPartyList['idList'] = this.selectedParty.map((ls) => ls.id);
    if (this.statusForApproval) {
      let objPoApprovalStatus: SearchData = {
        filterColumn: 'approvalStatus',
        filterValue: this.statusForApproval,
        filterOperator: null,
        filterCondition: null,
        filterDataType: null,
      };
      serverFilterObj.push(objPoApprovalStatus);
    }
    serverFilterObj.push(objPoPartyList);
    this.searchData = JSON.parse(JSON.stringify(serverFilterObj));
    this.getListWithParams(isPDF);
  }

  pageChange(event) {
    this.paginatioData = new PaginationData();
    this.paginatioData.pageNumber = event.pageIndex + 1;
    this.paginatioData.rowsPerPage = event.pageSize;
    this.getListWithParams();
  }

  onApprovalLogs(data: SalesOrderModal, onPOApprove) {
    let obj = {
      keyName: 'so_approval_flow',
    };
    this.commonService.getModuleApproval(obj).subscribe((res) => {
      this.moduleId = res.data.id;
      this.selectedSO = new SalesOrderModal();
      this.selectedSO = data;
      let obj1 = {
        entityId: data.id,
        moduleId: this.moduleId,
      };
      this.commonService.getEntityByStatus(obj1).subscribe((res) => {
        this.approvalConfigLog = new Array<ApprovalConfigLog>();
        this.approvalConfigLog = res.dataList;
        this.ngbRef = this.ngbModalService.open(onPOApprove, { size: 'lg', backdrop: 'static' });
      });
    });
  }

  onPrintHistory(printHistory, data) {
    this.selectedID = data.id;
    this.ngbRef = this.ngbModalService.open(printHistory, { windowClass: 'xlModal', backdrop: 'static' });
  }

  onSalesOrderPrintClick(soPrint, data: SalesOrderModal) {
    this.isHideHeaderFooter = false;
    this.isWorkOrder = false;
    this.ngbRef = this.ngbModalService.open(soPrint, { size: 'lg', backdrop: 'static' });
    let cb1 = document.getElementById('checkbox1');
    cb1['checked'] = true;
    let cb = document.getElementById('checkbox');
    cb['checked'] = false;
    setTimeout(() => {
      if (this.isLifeoline) {
        let cbWs1 = document.getElementById('checkboxWs1');
        cbWs1['checked'] = true;
        let cbWs = document.getElementById('checkboxWs');
        cbWs['checked'] = false;
      }
    }, 100);

    this.data = new SalesOrderModal();
    this.data = data;
  }

  onClickHideHeaderFooter(hide: boolean) {
    let cb = document.getElementById('checkbox');
    let cb1 = document.getElementById('checkbox1');
    if (hide) {
      cb['checked'] = true;
      cb1['checked'] = false;
      this.isHideHeaderFooter = true;
    } else {
      cb['checked'] = false;
      cb1['checked'] = true;
      this.isHideHeaderFooter = false;
    }
  }

  onClickWorkOrderOrSalesOrder(hide: boolean) {
    let cb = document.getElementById('checkboxWs');
    let cb1 = document.getElementById('checkboxWs1');
    if (hide) {
      cb['checked'] = true;
      cb1['checked'] = false;
      this.isWorkOrder = true;
    } else {
      cb['checked'] = false;
      cb1['checked'] = true;
      this.isWorkOrder = false;
    }
  }

  onClickSalesOrderPrint(printContent) {
    this.ngbRef.close();
    // this.isHideHeaderFooter = !this.isHideHeaderFooter;
    this.ngbRef = this.ngbModalService.open(printContent, { windowClass: 'xlModal', backdrop: 'static' });
  }
}
